module.exports = __webpack_public_path__ + "media/images/front/premium_lp/point02/th_03-9c41f38cd32135674e86aee522957c1d.jpg";